import React from 'react';
import { LandingV1 } from './pages/LandingV1';
import { LandingV3 } from './pages/LandingV3';
// Reads variant set by index.tsx before render — no re-computation here.
export function App() {
  const variant = (window as any).__abVariant;
  return variant === 'B' ? <LandingV3 data-id="element-0" /> : <LandingV1 data-id="element-1" />;
}